import { AfterViewInit, Component, computed, Input, signal, Signal } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BaseElement } from '../../../models/base-element';
import { Page } from '../../../models/page';
import { LocaleService } from '../../../services/locale.service';
import { NgClass, NgComponentOutlet, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'portal-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss'],
    imports: [NgClass, NgComponentOutlet, NgTemplateOutlet],
})
export class PageComponent {
  page: Page | null = null;
  hideHeader = signal(false);

  @Input() set element(value: BaseElement) {
    this.page = {} as Page;
    //  FPST-312 HACK: This timeout is required to ensure that we "blank" the page before inserting the new page. See FPST-312 for details.
    setTimeout(() => {
      const page = cloneDeep(value) as Page;
      this.page = page;
      if (this.page) {
        this.localeService.updatePageLocale(this.page.locale);
      }

      const hideHeader = !page.breadcrumbs?.length
        && !page.title?.length
        && !page.lead?.length;

      this.hideHeader.set(hideHeader);
    }, 1);
  }

  constructor(private localeService: LocaleService) { }
}
